import type { NeoArticleTreeNode, PDSArticle } from "@expert/types";

export default defineNuxtRouteMiddleware(async (to, from) => {
    const webcode = to.params.webcode ?? '';
    const slug = to.params.slug ?? '';

    const { data: articleTreeNode } = await useFetch<NeoArticleTreeNode>("/api/neo/article/treeNode/resolve", {
        query: {
            webcode,
            slug,
        },
    });

    const resolvedArticleSlug = articleTreeNode.value?.localizedProperties?.at(0)?.value?.lowerCaseSlug ?? `${webcode}-${slug}.html`.toLowerCase();
    if (`${webcode}-${slug}.html`.toLowerCase() !== resolvedArticleSlug || !to.params.parentCategory) {
        if (!to.params.parentCategory) {
            const { data: artpds } = await useFetch<PDSArticle>("/api/articlepds", {
                query: {
                    webcode, slug
                }
            });
            
            const redirectUrl = `/shop/unsere-produkte/${artpds?.value?.directArticleCategoryList?.at(0)?.slug}/${artpds?.value?.directArticleCategoryList?.at(1)?.slug}/${artpds?.value?.directArticleCategoryList?.at(2)?.slug}/${artpds?.value?.article?.slug}`;
            return navigateTo(`${artpds.value?.article?.link ?? redirectUrl}${to?.fullPath?.includes('?') ? '?' + to?.fullPath?.split('?')?.at(1) : ''}`, { redirectCode: 301 });
        } else {
            const redirectUrl = `/shop/unsere-produkte/${to.params.parentCategory}/${to.params.childCategory}/${to.params.productType}`;
            return navigateTo(`${redirectUrl}/${resolvedArticleSlug}${to?.fullPath?.includes('?') ? '?' + to?.fullPath?.split('?')?.at(1) : ''}`, { redirectCode: 301 });
        }
    }
});